// src/components/Admin/EditarLink.jsx
import React, { useState } from 'react';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification';
import LinkForm from './LinkForm';

const EditarLink = () => {
  const navigate = useNavigate();
  const [key, setKey] = useState('');
  const [initialData, setInitialData] = useState({});
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false); // Estado para controlar a visibilidade

  const handleFetchLink = async () => {
    if (!key) return; // Não faz nada se o campo Key estiver vazio
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, 'links'));
      const link = querySnapshot.docs.find((doc) => doc.data().key === key);
      if (link) {
        setInitialData(link.data());
        setShowForm(true); // Mostra o formulário de edição
      } else {
        setNotification({
          message: 'Link não encontrado!',
          type: 'error',
        });
      }
    } catch (error) {
      setNotification({
        message: 'Erro ao buscar link: ' + error.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, 'links'));
      const link = querySnapshot.docs.find((doc) => doc.data().key === key);
      if (link) {
        const docRef = doc(db, 'links', link.id); // Cria uma referência ao documento
        await updateDoc(docRef, formData); // Atualiza o documento
        setNotification({
          message: 'Link atualizado com sucesso!',
          type: 'success',
        });
        setTimeout(() => {
          navigate('/admin/dashboard');
        }, 2000);
      } else {
        setNotification({
          message: 'Link não encontrado!',
          type: 'error',
        });
      }
    } catch (error) {
      setNotification({
        message: 'Erro ao atualizar link: ' + error.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Formulário inicial (campo Key) */}
      {!showForm && (
        <div className="admin-form">
          <h2>Editar Link</h2>
          <div className="form-group">
            <label htmlFor="key">ID</label>
            <input
              type="text"
              id="key"
              placeholder="Digite o ID"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              required
            />
            <button
              type="button"
              className="fetch-button"
              onClick={handleFetchLink}
              disabled={loading}
            >
              {loading ? 'Buscando...' : 'Buscar Link'}
            </button>
          </div>
        </div>
      )}

      {/* Formulário de edição (campos preenchidos) */}
      {showForm && (
        <LinkForm
          initialData={initialData}
          onSubmit={handleSubmit}
          loading={loading}
          submitText="Salvar Alterações"
        />
      )}

      {/* Exibe a notificação se existir */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
    </>
  );
};

export default EditarLink;